import React from "react";

export const vozavosContext = React.createContext();
